/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TodoTemplate } from '../../models/todo-template';

export interface GetTodoTemplate$Params {

/**
 * Id of a resource.
 */
  id: string;
}

export function getTodoTemplate(http: HttpClient, rootUrl: string, params: GetTodoTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<TodoTemplate>> {
  const rb = new RequestBuilder(rootUrl, getTodoTemplate.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TodoTemplate>;
    })
  );
}

getTodoTemplate.PATH = '/api/v1/todo_templates/{id}';
